import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Gallery } from '../components/Gallery';
import { WhyUs } from '../components/WhyUs';
import { Testimonials } from '../components/Testimonials';
import { CTABanner } from '../components/CTABanner';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen flex flex-col" data-id="element-160">
      <Navbar data-id="element-161" />
      <main className="flex-grow" data-id="element-162">
        <Hero data-id="element-163" />
        <Services data-id="element-164" />
        <Gallery data-id="element-165" />
        <WhyUs data-id="element-166" />
        <Testimonials data-id="element-167" />
        <CTABanner data-id="element-168" />
      </main>
      <Footer data-id="element-169" />
    </div>;
}